<page-load-header *ngIf="!initialized"></page-load-header>
<h3>{{ 'my-upcoming-events' | translate }}</h3>
<div *ngIf="initialized">
  <ul class="nav nav-tabs nav-mobile-icons">
    <li class="nav-item"><a class="nav-link" [routerLink]="['conferences']" [routerLinkActive]="'active'">Conferences</a></li>
    <li class="nav-item"><a class="nav-link" [routerLink]="['individual-events']" [routerLinkActive]="'active'">A-la-carte Events</a></li>
  </ul>
  <div class="container-fluid bg-white tab-container">
    <router-outlet></router-outlet>
  </div>
</div>
